import { forwardRef } from 'react';
import { Button as MuiButton, ButtonProps } from '@mui/material';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ disabled, sx, ...props }, ref) => {
    return (
      <MuiButton
        {...props}
        ref={ref}
        disableRipple
        disabled={disabled}
        sx={{
          opacity: disabled ? '.5' : '1',
          transition: 'opacity 0.3s ease-in-out',

          p: '10px 14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'auto',
          gap: '8px',

          borderRadius: '8px',
          border: '1px solid var(--Gray-300, #D0D5DD) !important',
          background: 'var(--White, #FFF) !important',

          color: '#344054',

          fontFamily: 'Inter, sans-serif',
          fontSize: 14,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          alignSelf: 'center',
          '&:hover': {
            color: '#344054',
            background: '#F9FAFB !important',
          },
          ...sx,
        }}
      />
    );
  },
);
